import { styled } from "@mui/system";
import { CardContainer } from "./CardContainer";
import useThemeContext from "../hooks/useThemeContext";

const Containers = () => {
  const { sidebarNav } = useThemeContext();

  const ChartContainer = styled(CardContainer)(({ theme }) => ({
    overflow: "hidden",
    [theme.breakpoints.between("sm", "md")]: {
      width: sidebarNav ? "calc(100vw - 170px)" : "calc(100vw - 50px)",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: sidebarNav ? "calc(100vw - 180px)" : "calc(100vw - 60px)",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "calc(100vw - 50px)",
    },
  }));

  const TableContainer = styled(CardContainer)(({ theme }) => ({
    overflowX: "auto",
    [theme.breakpoints.between("sm", "md")]: {
      overflowX: "auto",
      width: sidebarNav ? "calc(100vw - 170px)" : "calc(100vw - 50px)",
    },
    [theme.breakpoints.down("lg")]: {
      overflowX: "auto",
      maxWidth: sidebarNav ? "calc(100vw - 180px)" : "calc(100vw - 60px)",
    },
    [theme.breakpoints.down("md")]: {
      overflowX: "auto",
      maxWidth: "calc(100vw - 50px)",
    },
  }));

  return {
    ChartContainer,
    TableContainer,
  };
};

export default Containers;
